import { useEffect } from 'react';

import CautionTriangleLogo from '../../assets/grv-caution-triangle.svg?react';

import './Toast.scss';

const AUTO_HIDE_DURATION_MS = 5000;

interface ToastProps {
  isVisible: boolean;
  message: string;
  onClose: () => void;
  autoHideDuration?: number;
}

export const Toast = ({
  message,
  isVisible,
  onClose,
  autoHideDuration = AUTO_HIDE_DURATION_MS,
}: ToastProps) => {
  useEffect(() => {
    let timer: number | null = null;

    if (isVisible) {
      timer = window.setTimeout(() => {
        onClose();
      }, autoHideDuration);
    }

    return () => {
      if (timer !== null) {
        window.clearTimeout(timer);
      }
    };
  }, [isVisible, onClose, autoHideDuration]);

  if (!isVisible) return null;

  return (
    <div className="toast" role="alert" aria-live="assertive">
      <div className="toast-content">
        <CautionTriangleLogo className="toast-logo" />
        <span className="toast-message">{message}</span>
        <button
          className="toast-close-button"
          onClick={onClose}
          aria-label="Close notification"
          type="button"
        >
          ×
        </button>
      </div>
    </div>
  );
};
